import { useEffect } from "react";
import { createPortal } from "react-dom";

export function Overlay({ onClose, z = 1100, className = "", children }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return createPortal(
    <div className={`fixed inset-0 bg-slate-950/50 ${className}`} style={{ zIndex: z, marginTop: 0 }} onClick={onClose}>{children}</div>,
    document.body,
  );
}
